import ActionLinkButton from '@/common/components/ActionLinkButton'
import { formatDateInLocalTimezone } from '@/common/utils/formatters'
import {
  FederalLotteriesContestData,
  FederalLotteriesContestTableItem,
} from '@/features/federalLotteries/types/federalLottery.type'

export class FederalLotteryTransformer {
  static tableTransformer() {
    return (contests: FederalLotteriesContestData[]): FederalLotteriesContestTableItem[] => {
      return contests.map((contest) => ({
        id: contest.id,
        number: contest.number,
        date: contest.date ? formatDateInLocalTimezone(contest.date) : '',
        actions: (
          <ActionLinkButton
            linkTo={contest.id}
            operationKlassToCheckPermission="Admin::Tmais::FederalLotteries::Show"
            dataTestid="access_federal_lottery_contest_button"
          />
        ),
      }))
    }
  }
}
